module.exports = function () {
    var calculateSpeed = function (distance) {
        return distance / 3000 * 1000;
    };

    var $page = $("div[class*='landing']")[0];

    $($page).find("[class*='landing__table-of-contents'] li a").click(function () {
        var targetAnchor = $(this).data('contentsTarget');
        var targetName = $(this).data('contentsName');
        var targetIndex = $(this).data('contentsIndex');

        var $targetElement = $('#' + targetAnchor);
        if ($targetElement.length) {
            var baseOffset = ICF.Utils.Breakpoints.IsDesktop() ? 0 : 80;
            var offset = $targetElement.offset().top - baseOffset;

            var distance = Math.abs($(window).scrollTop() - offset);

            var speed = calculateSpeed(distance);

            $([document.documentElement, document.body]).animate({
                scrollTop: offset
            }, speed);
        }

        var $nearestUl = $(this).closest("[class*='landing__table-of-contents']").find('ul');
        $nearestUl.removeClass(function(index, className) {
          return (className.match(/landing__table-of-contents--open$/))
        });

        $contentActive = $nearestUl.siblings("[class*='landing__table-of-contents-active']");

        $contentActive.find("[class*='landing__table-of-contents-active__name']").text(targetName);
        $contentActive.find("[class*='landing__table-of-contents-active__index']").text(targetIndex);

        return false;
    });

    $("[class*='landing__table-of-contents-active']").click(function () {
        var pageLandingClass = $($page).attr('class').split(' ').shift();
        var nameOfClass = pageLandingClass + '__table-of-contents--open';

        $(this).siblings('ul').first().toggleClass(nameOfClass);

        return false;
    });

    if ($("[class*='landing__table-of-contents']").length) {
        var resize = function () {
            var $list = $("[class*='landing__table-of-contents'] ul");
            var height = 24;
            $list.find('li').each(function (i, elem) {
                height += $(elem).outerHeight(true);
            });
            $list.css('height', height + 'px');
        };
        resize();
        $(window).resize(function () {
            requestAnimationFrame(resize);
        });

        Stickyfill.add($("[class*='landing__table-of-contents']")[0]);
    }

    var determineCurrentActiveSection = function () {
        var currentPagePosition = $(window).scrollTop();

        var targetAnchors = $('[data-contents-target]');

        var targets = [];
        targetAnchors.each(function () {
            var targetAnchor = $(this).data('contentsTarget');
            var $target = $('#' + targetAnchor);

            targets.push($target);
        });

        var $currentActiveSection = null;
        var currentActiveSectionIndex = 0;

        for (var i = 0; i < targets.length - 1; ++i) {
            var navHeight = $('.main-header').height();
            var tableOfContentsHeight = $("[class*='landing__table-of-contents']").outerHeight();
            var pageOffset = navHeight + tableOfContentsHeight;

            var currentItemPosition = targets[i].offset().top - pageOffset;
            var nextItemPosition = targets[i + 1].offset().top - pageOffset;

            if (currentPagePosition < currentItemPosition || currentPagePosition < nextItemPosition) {
                $currentActiveSection = targets[i];
                break;
            }

            ++currentActiveSectionIndex;
        }

        if ($currentActiveSection === null) {
            $currentActiveSection = targets[targets.length - 1];
        }

        var activeTarget = $(targetAnchors[currentActiveSectionIndex]);

        var activeName = activeTarget.data('contentsName');
        var activeIndex = activeTarget.data('contentsIndex');

        var $tableOfContents = $("[class*='landing__table-of-contents-active']");
        $tableOfContents.find("[class*=landing__table-of-contents-active__name']").text(activeName);
        $tableOfContents.find("[class*=landing__table-of-contents-active__index']").text(activeIndex);
    };

    $(document).scroll(function () {
        requestAnimationFrame(determineCurrentActiveSection);
    });
};